import { render, staticRenderFns } from "./orderRefundConfirm.vue?vue&type=template&id=10b087ae&scoped=true&"
import script from "./orderRefundConfirm.vue?vue&type=script&lang=js&"
export * from "./orderRefundConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b087ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b087ae')) {
      api.createRecord('10b087ae', component.options)
    } else {
      api.reload('10b087ae', component.options)
    }
    module.hot.accept("./orderRefundConfirm.vue?vue&type=template&id=10b087ae&scoped=true&", function () {
      api.rerender('10b087ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/order/orderRefund/orderRefundConfirm.vue"
export default component.exports